import _ from 'lodash'
import $ from 'jquery'
// import Hammer from 'hammerjs'
// import 'jquery-hammerjs'
import * as c from '../../constants/Constants'
import * as Utils from './util/Utils'


const SPEED = 6
const VENDOR_PREFIX = (function () {

  var regex = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/,

    styleDeclaration = document.getElementsByTagName("script")[ 0 ].style;

  for (var prop in styleDeclaration) {
    if (regex.test(prop)) {
      return prop.match(regex)[ 0 ].toLowerCase();
    }
  }

  // Nothing found so far? Webkit does not enumerate over the CSS properties of the style object.
  // However (prop in style) returns the correct value, so we'll have to test for
  // the precence of a specific property
  if ("WebkitOpacity" in styleDeclaration) { return "webkit"; }
  if ("KhtmlOpacity" in styleDeclaration) { return "khtml"; }

  return "";
}());

const createjs = window.createjs

const _ua = (function(){
  return {
    IE9:document.uniqueID && document.documentMode == 9,
    IE10:document.uniqueID && document.documentMode == 10,
    IE11:document.uniqueID && document.documentMode == 11,
    Trident:document.uniqueID,
    Edge:'-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style && !window.navigator.msPointerEnabled,
    Gecko:'MozAppearance' in document.documentElement.style,
    Presto:window.opera,
    Blink:window.chrome && window.chrome.webstore,
    Webkit:!window.chrome && 'WebkitAppearance' in document.documentElement.style,
    Touch:typeof document.ontouchstart != "undefined",
    Mobile:typeof window.orientation != "undefined",
    ltAd44:typeof window.orientation != "undefined" && typeof(EventSource) == "undefined",
    Pointer:window.navigator.pointerEnabled,
    MSPoniter:window.navigator.msPointerEnabled
  }
})();

export default class MovingContainer {

  constructor (stage, exportRoot, setMouseDown, setScrollPosition) {
    this.canMove = NaN;
    this.stage = stage;
    this.exportRoot = exportRoot;
    this.setMouseDown = setMouseDown;
    this.setScrollPosition = setScrollPosition;
    
    this.animloop()
  }

  animloop () {
    requestAnimationFrame(this.animloop.bind(this));
    this.moveContainer(this.checkWinWidth())
    // if (!this.mousedown && !this.mouseleave && this.mouseY <= 602) {
    //   const iw = window.innerWidth;
    //   if (this.mouseX < iw / 2 - 100) {
        // this.changeContainerX(this.exportRoot.container.x + SPEED);
      // } else if (this.mouseX > iw / 2 + 100) {
        // this.changeContainerX(this.exportRoot.container.x - SPEED);
      // }
    // }
  }

  checkWinWidth () {
    const iw = window.document.documentElement.clientWidth;
    return iw < c.CT_W
  }

  moveContainer (canMove) {
    if (this.canMove !== canMove) {
      this.canMove = canMove
      this.handleCtrl(canMove)
    }
  }

  handleCtrl (enabled) {
    
    const $win = $(window)
    const $canvas = $("#canvas")
    const container = this.exportRoot.container
    const container_up = this.exportRoot.container_up
    
    
    const move_arrow_l = this.exportRoot.move_arrow_l
    const move_arrow_r = this.exportRoot.move_arrow_r
    
    const stage = this.stage
    
    this._pressmoveHandler = this._pressmoveHandler || pressmoveHandler.bind(this);
    this._mousedownHandler = this._mousedownHandler || mousedownHandler.bind(this);
    this._mouseupHandler = this._mouseupHandler || mouseupHandler.bind(this);
    this.baseX = this.exportRoot.container.x
    move_arrow_l.addEventListener("click", () => {
      Utils.tweenContainerX(this.baseX + window.document.documentElement.clientWidth, stage, container, container_up, this.setScrollPosition);
    })
    move_arrow_r.addEventListener("click", () => {
      Utils.tweenContainerX(this.baseX - window.document.documentElement.clientWidth, stage, container, container_up, this.setScrollPosition);
    })
    
    
    if (enabled) {
      this.setCursor("grab")

      // $win
      //   .on("mousemove", mousemoveHandler.bind(this))
      //   .on("mousedown mouseup", mouseupdownHandler.bind(this));
      
      // $canvas
      //   .on("mouseenter mouseleave", mouseEnterLeaveHandler.bind(this))
      // $canvas 
      //   .hammer({ direction: Hammer.DIRECTION_VERTICAL })
      //   .bind("panleft panright", _.throttle(panHandler.bind(this), 100).bind(this))

      container.addEventListener("pressmove", this._pressmoveHandler);
      container.addEventListener("mousedown", this._mousedownHandler);
      container.addEventListener("pressup", this._mouseupHandler);

    } else {
      container.removeEventListener("pressmove", this._pressmoveHandler);
      container.removeEventListener("mousedown",this. _mousedownHandler);
      container.removeEventListener("pressup", this._mouseupHandler);

      // $win
      //   .off("mousemove")
      //   .off("mousedown mouseup")
      // $canvas
      //   .off("mouseenter mouseleave")
      // const hammer = $canvas.data("hammer")
      // try{
      //   if (hammer) {
      //     hammer.destroy()
      //     $canvas.data("hammer", null)
      //   }
      // } catch(e){}

      this.exportRoot.container.x = 0
      this.exportRoot.container_up.x = 0
      this.setCursor("auto")
    }

    function mouseEnterLeaveHandler (e) {
      switch (e.type) {
        case "mouseenter":
          this.mouseleave = false
          break;
        case "mouseleave":
          this.mouseleave = true
          break;
      }
    }

    function mousemoveHandler (e) {
      this.mouseX = e.pageX
      this.mouseY = e.pageY
    }

    function mouseupHandler (e) {
      // switch (e.type) {
      //   case "mousedown":
      //     this.setCursor("grabbing")
      //     this.mousedown = true
      //     this.baseX = this.exportRoot.container.x
      //     this.setFrameRate(7)
      //    
      //     break;
      //    
      //   case "mouseup":
          this.setCursor("grab")
          this.mousedown = false
          // this.mouseleave = true
          this.baseX = this.exportRoot.container.x
          this.setFrameRate(24)
          this.setCaptureScreen(false)
          // break;
      // }
      this.setMouseDown(this.mousedown)

    }

    function mousedownHandler (e) {
      dragPointX = stage.mouseX - container.x;
      // switch (e.type) {
      //   case "mousedown":
          this.setCursor("grabbing")
          this.mousedown = true
          this.baseX = this.exportRoot.container.x
          this.setFrameRate(7)
          this.setCaptureScreen(true)

      //    
      //     break;
      //    
      //   case "mouseup":
      // this.setCursor("grab")
      // this.mousedown = true
      // this.mouseleave = true
      // this.baseX = this.exportRoot.container.x
      // this.setFrameRate(24)
      // break;
      // }
      this.setMouseDown(this.mousedown)
    }

    function panHandler (e) {
      var x = e.gesture.deltaX
      // this.changeContainerX(this.baseX + x);
      Utils.changeContainerX(this.baseX + x, stage, container, container_up, this.setScrollPosition);
    }
    
    let dragPointX

    function pressmoveHandler (e) {
      if(!this.mousedown) return;
      // container.x = stage.mouseX - dragPointX;
      // var x = e.gesture.deltaX
      
      Utils.changeContainerX(stage.mouseX - dragPointX, stage, container, container_up, this.setScrollPosition);
    }
    
    // function mousedownHandler(e) {
    //   dragPointX = stage.mouseX - container.x;
    // }
  }

  setCursor (prop) {
    switch (prop) {
      case "grab":
      case "grabbing":
        if(
          window.document.documentMode &&
          typeof window.document.documentMode === "number" &&
          window.document.documentMode <= 11
        ) {
          this.exportRoot.cursor = "move";
        } else {
          if (VENDOR_PREFIX) {
            this.exportRoot.cursor = `-${VENDOR_PREFIX}-${prop}`
          } else {
            this.exportRoot.cursor = prop
          }
        }
        break;
      case "auto":
        this.exportRoot.cursor = null
        break;
    }
  }

  // changeContainerX (x) {
  //   const stage = this.stage
  //   const sc = stage.scaleX
  //   const iw = window.innerWidth
  //   const ctwh = c.CT_W / 2
  //   const ctwhMin = ctwh*sc
  //   const ctwhSa = (ctwh-ctwhMin)
  //   const iwh = iw / 2
  //   let min = (ctwh - iwh)-(ctwhSa*1.2)
  //   let max = (-ctwh + iwh)+(ctwhSa*0.8)
  //   x = Math.min(x, min)
  //   x = Math.max(x, max)
  //   if (this.exportRoot.container.x !== x) {
  //     this.exportRoot.container.x = x
  //   }
  // }
  
  setFrameRate(rate) {
    // if(_ua.Webkit || _ua.IE9 || _ua.IE10 || _ua.IE11) {
    if(_ua.IE9 || _ua.IE10 || _ua.IE11) {
      createjs.Ticker.framerate = rate;
    }

  }

  setCaptureScreen(enabled) {
    // if(_ua.IE9 || _ua.IE10 || _ua.IE11) {
      const container = this.exportRoot.container
      switch (enabled) {
        case true:
          const bd = container.getBounds()
          container.cache(bd.x, bd.y, bd.width, bd.height)
          this.tick = this.tick || tick
          break;
        case false:
          container.uncache();
          break;
      }
      function tick(e) {
        console.log(e);
        e.preventDefault();
        e.stopPropagation();
        return false
      }
  }
  // }
  
}


/** WEBPACK FOOTER **
 ** ./src/components/canvas/MovingContainer.js
 **/